import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import { ROUTES } from '../constants/routes';
import { useGreetingUser } from '../../common/hooks/useWelcomingText';
import { UserButton } from '@clerk/clerk-react';
import { useAuth, useOrganizationList } from '@clerk/clerk-react';
import { PermissionsGate } from '../roles-gate';
import { USER_PERMISSIONS } from '../constants/permissions';

const AppBar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { orgId } = useAuth();
  const { setActive, userMemberships } = useOrganizationList({
    userMemberships: {
      // Set pagination parameters
      pageSize: 1,
      keepPreviousData: true,
    },
  });
  const path = location.pathname;

  const { greeting, date } = useGreetingUser();

  useEffect(() => {
    const memOrgId = userMemberships?.data?.at(0)?.organization.id;
    if (memOrgId) {
      if (orgId != memOrgId) {
        setActive({ organization: memOrgId });
      }
    }
  }, [userMemberships, orgId, setActive]);
  return (
    <>
      <div className='application-bar'>
        <Container maxWidth='lg' className='d-flex justify-content-between align-items-center'>
          {path === ROUTES.HOME && (
            <div className='name-date-container'>
              <div className='name-container'>
                <h1>{greeting}</h1>
              </div>
              <div className='date-container'>{date}</div>
            </div>
          )}
          <div className='flex-grow-1'></div>
          <div className='actions-container d-flex align-items-center position-relative'>
            <a
              className='app-bar-link'
              href='https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1itJ_5Em1JU5o_x5yPX-ARg9ikUcJdxWvX2XCAVTshocDAoPHsmXrzqdwTvyyFVsFuo4pN9PEo'
              target='_blank'
              rel='noreferrer'
            >
              <CalendarMonthIcon />
              {t('buttons.bookADemo')}
            </a>
            {path === ROUTES.HOME && (
              <PermissionsGate permission={[USER_PERMISSIONS.ORG_DOCUMENT_LIBRARY_READ]}>
                <Link
                  className='app-bar-link app-bar-link--template-library'
                  to={ROUTES.DOCUMENT_LIBRARY + '?businessKitzLibrary=true'}
                >
                  <CollectionsBookmarkIcon />
                  {'Document library'}
                </Link>
              </PermissionsGate>
            )}
            {/* <div className='notifications'>
            <NotificationsUnreadIcon />
          </div> */}
            {<UserButton />}
          </div>
        </Container>
      </div>
    </>
  );
};
export default AppBar;
